// CONSTANTS are all caps.
const NS = 'VideoFeature';
const CLS = 'videoFeature';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
import videobox from 'videobox';

export class VideoFeature {

	constructor($el) {
		// $el is the blk node return by the loadVideoFeature function
		this.$el = $el;
	}

	init() {
		this.setVideoFeature();		
	}

	setVideoFeature() {
		let $this = $(this.$el);
		let $width = window.innerWidth;
		if ($this.find('.btn-play').attr('data-screen') === 'full') {
			let $el = $this.find('.btn-play');
			let datavideo = `"width" : ${window.innerWidth - 100} ,"height": ${window.innerHeight - 150}`;
			$el.attr('data-videobox', `{${datavideo}}`);
		}
	}
	// Add more functions like on above here
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/blocks/videoFeature/js/videoFeature.js